import { ISectionContainerProps } from "component-library";
import { ReactComponent as WarningIcon } from "assets/icons/status/warning-icon.svg";
import { ReactComponent as WarningThinIcon } from "assets/icons/status/warning-icon-thin.svg";
import { AlertConfigBuilder } from "shared/utils/alert-config-builder";

import { IAudioPageFormContent } from "./components/AudioPageForm";

export interface IDisplayLimitAlert {
  displayLimitAlertTitle: string;
  displayLimitAlertDescription: string;
  displayLimitAlertCloseButton: string;
}

export interface IAudioPageContent {
  header: string;
  closeButton: string;
  addNewAudioButton: string;
  returnToProfileButton: string;
  agentCVLink: string;
  performerCVLink: string;
  deletePopup: {
    deletePopupDescription: string;
    deletePopupCloseButtonText: string;
    deletePopupContinueButtonText: string;
    deletePopupTitle: string;
  };
  copyrightPopup: {
    copyrightPopupCloseButtonText: string;
    copyrightPopupDescription: string;
    copyrightPopupTitle: string;
    copyrightPopupContinueButtonText: string;
  };
  displayLimitAlert: IDisplayLimitAlert;
  editAudioListForm: IAudioPageFormContent;
}

export const IAudioPageContentKeys = [
  "header",
  "closeButton",
  "addNewAudioButton",
  "returnToProfileButton",
  "agentCVLink",
  "performerCVLink",
  "deletePopup",
  "copyrightPopup",
  "displayLimitAlert",
  "editAudioListForm",
];

export const getSectionContainerProps = (
  content: IAudioPageContent,
  handleCloseClick: () => void
): ISectionContainerProps => {
  return {
    header: content.header,
    variant: "shadowed",
    controls: [
      {
        text: content.closeButton,
        onClick: handleCloseClick,
      },
    ],
  };
};

export const getAlertMessage = (
  content: IAudioPageContent,
  popupType: PopupTypes,
  handleActionClick: () => void,
  cancelAction: () => void,
  iconType: "warning" | "notice" = "warning"
) => {
  const popupContent = content[popupType];
  const icon = iconType === "warning" ? <WarningIcon /> : <WarningThinIcon />;

  return new AlertConfigBuilder()
    .initBuildEntity()
    .setDefaultContent({
      closeButtonText: popupContent[`${popupType}CloseButtonText`],
      description: popupContent[`${popupType}Description`],
      title: popupContent[`${popupType}Title`],
    })
    .setAlertProps({ icon })
    .setCloseButton({ type: "secondary", click: cancelAction })
    .addButton({
      type: "primary",
      click: handleActionClick,
      name: popupContent[`${popupType}ContinueButtonText`],
    })
    .build();
};

export const getDisplayLimitAlert = (
  content: IDisplayLimitAlert,
  closeAction: () => void
) =>
  new AlertConfigBuilder()
    .initBuildEntity()
    .setDefaultContent({
      title: content.displayLimitAlertTitle,
      description: content.displayLimitAlertDescription,
      closeButtonText: content.displayLimitAlertCloseButton,
    })
    .setCloseButton({ type: "primary", click: closeAction })
    .build();

export enum PopupTypes {
  Delete = "deletePopup",
  Copyright = "copyrightPopup",
}
